import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import jQuery from 'jquery';
import 'sweetalert2/dist/sweetalert2.min.css';
import {Tabs, Tab} from 'vue3-tabs-component';
import  VueCookies from 'vue-cookies'


window.$ = window.jQuery = jQuery;
const app = createApp(App);
app.config.globalProperties.$cookies = VueCookies;
// eslint-disable-next-line vue/multi-word-component-names
app.component('tabs',Tabs)
// eslint-disable-next-line vue/multi-word-component-names
app.component('tab',Tab)

app.use(VueCookies);
app.use(router);
app.mount('#app');

